<template>
  <div class="user">
    <img
      :src="currentCenterImage.replace('/files/', '/media/260/')"
      :alt="getMyCurrentCenter.name"
      width="94%"
      style="margin: 0 2%;"
    />
    <div v-if="getMyCurrentCenter" class="photo">
      <!--      <img :src="currentCenterImage" :alt="getMyCurrentCenter.name" />-->
    </div>
    <div v-else class="md-layout md-alignment-space-around-center">
      <md-button
        class="md-success"
        @click="
          $router.push(
            localePath({
              name: 'center-center_id',
              params: { center_id: 'add' }
            })
          )
        "
        >{{ $t('center.create.button') }}</md-button
      >
    </div>
    <div v-if="getMyCurrentCenter" class="user-info">
      <a
        :aria-expanded="!isClosed"
        data-toggle="collapse"
        @click.stop="toggleMenu"
        @click.capture="clicked"
      >
        <span>
          {{ getMyCurrentCenter.name }}
          <b class="caret"></b>
        </span>
      </a>

      <collapse-transition>
        <div v-show="!isClosed">
          <ul class="nav">
            <slot>
              <li v-if="getCenterToken">
                <router-link
                  :to="
                    localePath({
                      name: 'center-center_id',
                      params: { center_id: 'current' }
                    })
                  "
                >
                  <span class="sidebar-mini">{{ $t('center.edit_mini') }}</span>
                  <span class="sidebar-normal">{{ $t('center.edit') }}</span>
                </router-link>
              </li>
              <li>
                <router-link :to="localePath('account-profile')">
                  <span class="sidebar-mini">{{
                    $t('sidebar.account.profile_mini')
                  }}</span>
                  <span class="sidebar-normal">{{
                    $t('sidebar.account.profile')
                  }}</span>
                </router-link>
              </li>
              <!--              <li>
                <router-link :to="localePath('account-teacher')">
                  <span class="sidebar-mini">{{
                    $t('sidebar.account.teacher_mini')
                  }}</span>
                  <span class="sidebar-normal">{{
                    $t('sidebar.account.teacher')
                  }}</span>
                </router-link>
              </li>-->
              <!--              <li>
                <router-link :to="localePath('center-detail')">
                  <span class="sidebar-mini">{{ $t('center.edit_mini') }}</span>
                  <span class="sidebar-normal">{{ $t('center.edit') }}</span>
                </router-link>
              </li>-->
              <sidebar-item
                v-if="getMyCurrentCenter"
                :link="{ name: $t('header.menu.my_centers'), icon: 'list' }"
              >
                <li v-for="c in getMyCenters" :key="c.id">
                  <a href="javascript:void(0)" @click="setCurrentCenter(c)">
                    <span class="photo">
                      <img
                        :src="
                          getCenterImage(c).replace('/files/', '/media/30/')
                        "
                        alt="Structure image"
                      />
                    </span>
                    <span class="user-info">
                      <span>
                        {{ c.name }}
                      </span>
                    </span>
                  </a>
                </li>
                <sidebar-item
                  :link="{
                    name: $t('center.create.button'),
                    path: localePath({
                      name: 'center-center_id',
                      params: { center_id: 'add' }
                    })
                  }"
                ></sidebar-item>
              </sidebar-item>
            </slot>
          </ul>
        </div>
      </collapse-transition>
    </div>
  </div>
</template>
<script>
import { CollapseTransition } from 'vue2-transitions'
import Vuex from 'vuex'
import { tools } from '@/plugins/tools.js'

export default {
  components: {
    CollapseTransition
  },
  props: {},
  data() {
    return {
      isClosed: true,
      tools
    }
  },
  computed: {
    ...Vuex.mapGetters('center', [
      'getMyCenters',
      'getMyCurrentCenter',
      'getCenterToken'
    ]),
    currentCenterImage() {
      return this.tools.getCenterImage(this.getMyCurrentCenter)
    }
  },
  mounted() {},
  methods: {
    ...Vuex.mapMutations('center', ['setMyCurrentCenter', 'setCenterToken']),
    clicked(e) {
      e.preventDefault()
    },
    toggleMenu() {
      this.isClosed = !this.isClosed
    },
    getCenterImage(center) {
      let thumbnailCenterImage = false
      if (center && center.image) {
        if (center.image.children) {
          center.image.children.forEach(function(childImage) {
            if (!thumbnailCenterImage) {
              if (
                childImage.size &&
                childImage.size === '872x250' &&
                childImage.webPath
              ) {
                thumbnailCenterImage = childImage.webPath.replace(
                  'http://',
                  'https://'
                )
              }
            }
          })
        }
        if (!thumbnailCenterImage && center.image.webPath) {
          thumbnailCenterImage = center.image.webPath.replace(
            'http://',
            'https://'
          )
        }
      }
      if (!thumbnailCenterImage) {
        thumbnailCenterImage = require('@/static/img/empty-img.png')
      }
      return thumbnailCenterImage
    },
    setCurrentCenter(center) {
      try {
        this.$nuxt.$loading.start()
        this.setMyCurrentCenter(center)
        this.tools.retrieveUserInformations([center], this)
        this.tools.notifySuccess(this)
      } catch (e) {
        this.tools.notifyError(e, this)
      } finally {
        this.$nuxt.$loading.finish()
      }
    }
  }
}
</script>

<style lang="scss" scoped="">
.sidebar .user {
  margin-top: 0px;
}
.collapsed {
  transition: opacity 1s;
}
.sidebar-wrapper {
  .user {
    .photo {
      img {
        object-fit: cover;
        height: 100%;
      }
    }
  }
}
</style>
